import React, { Component } from "react";
import Logout from "../../assets/logout.svg";
import Back from "../../assets/back.svg";
import filter from "../../assets/filter.png";
import blocklistwhite from "../../assets/blocklistwhite.svg";
import ReportButtons from "../../components/ReportButtons";
import DetailCell from "../../components/DetailCell";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { NumericFormat } from "react-number-format";
import CustomButton from "../../components/CustomButton";
import { Modal, Form } from "react-bootstrap";
import Cancel from "../../assets/cancel.svg";
import Tick from "../../assets/tick.svg";
import { WhisperSpinner } from "react-spinners-kit";
import { toast } from "react-toastify";
import Paginator from "../../components/Paginator";
import PieChart, {
  Connector,
  Font,
  SmallValuesGrouping,
  Size,
} from "devextreme-react/pie-chart";
import DatePicker, { DateObject } from "react-multi-date-picker";
import moment from "moment-jalaali";
import "react-multi-date-picker/styles/layouts/mobile.css";
import "react-multi-date-picker/styles/layouts/prime.css";
import "react-multi-date-picker/styles/colors/bluee.css";
import fileExcel from "@iconify/icons-la/file-excel";
import downloadIcon from "@iconify/icons-la/download";
import { Series, Label, Legend } from "devextreme-react/chart";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import ListViewer from "../../components/ListViewer";
import PollReports from "../../components/PollReports";
import {
  BaseUrl,
  Authorization,
  isUser,
  LogoutFunction,
  ClubAuthorization,
} from "../../static.js";
import "../../App1.css";
import Tooltip from "@mui/material/Tooltip";

const mobileRegex = RegExp(/09(0[0-9]|1[1-9]|2[1-9]|3[0-9]|9[0-9])-?[0-9]{7}/);

export default class Reports extends Component {
  constructor(props) {
    super(props);
    this.formatCurrency = this.formatCurrency.bind(this);
    this.creditValue = this.creditValue.bind(this);
    this.state = {
      gridLocaleText: {
        selectAll: "انتخاب همه",
        selectAllSearchResults: "انتخاب همه نتایج جستجو",
        searchOoo: "جستجو...",
        blanks: "خالی",
        noMatches: "پشدا نشد",
        filterOoo: "فیلتر...",
        equals: "مساوی",
        notEqual: "نا مساوی",
        lessThan: "کمتر از",
        greaterThan: "بیشتر از",
        lessThanOrEqual: "کوچکتر مساوی",
        greaterThanOrEqual: "بزرگتر مساوی",
        inRange: "در محدوده",
        inRangeStart: "به",
        inRangeEnd: "از",
        contains: "شامل",
        notContains: "شامل نباشد",
        startsWith: "شروع با",
        endsWith: "پایان با",
        andCondition: "و",
        orCondition: "یا",
        applyFilter: "تایید",
        resetFilter: "راه اندازی مجدد",
        clearFilter: "پاک کردن",
        cancelFilter: "انصراف",
        columns: "ستون ها",
        filters: "فیلترها",
        group: "گروه",
        loadingOoo: "لطفاً شکیبا باشید...",
        noRowsToShow: "هیچ موردی یافت نشد",
        enabled: "فعال",
        sum: "جمع",
        min: "کمترین",
        max: "بیشترین",
        none: "None",
        count: "تعداد",
        avg: "میانگین",
        filteredRows: "فیلتر شده",
        selectedRows: "انتخاب شده",
        totalRows: "جمع ردیف ها",
        totalAndFilteredRows: "ردیف ها",
        page: "صفحه",
        more: "بیشتر",
        to: "تا",
        of: "از",
        next: "بعدی",
        last: "آخرین",
        first: "اولین",
        previous: "قبلی",
      },
      rowData: [],
      columnDefs: [
        {
          headerName: "نام",
          field: "name",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "موبایل",
          field: "phone",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "اعتبار",
          field: "credit",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "مبلغ آخرین فاکتور",
          field: "lastInvoiceAmount",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تاریخ آخرین فاکتور",
          field: "lastInvoicePersianDate",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "گروه",
          field: "groupName",
          // cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "عملیات",
          field: "id",
          cellRenderer: "fotmatEditCell",
          cellRendererParams: {
            GetCreditsOfAccount: this.GetCreditsOfAccount.bind(this),
            GetInvoicesOfAccount: this.GetInvoicesOfAccount.bind(this),
            GetSMSesOfAccount: this.GetSMSesOfAccount.bind(this),
            GetDiscountHistoryOfAccount:
              this.GetDiscountHistoryOfAccount.bind(this),
          },
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
            minWidth: "120px",
          },
          lockPosition: true,
        },
      ],
      frameworkComponents: {
        fotmatEditCell: ReportButtons,
        formatCurrency: this.formatCurrency,
        formatBool: this.formatBool,
        formatDetailCell: DetailCell,
        formatNumber: this.formatNumber,
        formatServiceName: this.formatServiceName,
        formatTextContent: this.formatTextContent,
      },

      customerRowData: [],
      customerColumnDefs: [],
      customerColumnDefs1: [
        {
          headerName: "نام",
          field: "name",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "اعتبار",
          field: "credit",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "اعتبار استفاده شده",
          field: "usedCredit",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تاریخ ایجاد",
          field: "persianCreatedOn",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تاریخ انقضا",
          field: "persianExpireDate",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
      ],
      customerColumnDefs2: [
        {
          headerName: "شماره فاکتور",
          field: "foreignId",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "مبلغ کل",
          field: "totalPrice",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "مبلغ کل اعتبار",
          field: "totalGetCredit",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تخفيف",
          field: "discount",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تاریخ ایجاد",
          field: "persianCreatedOn",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "جزئیات",
          field: "foreignId",
          cellRenderer: "formatDetailCell",
          cellRendererParams: {
            getInvoiceDetail: this.getInvoiceDetail.bind(this),
            getInvoiceCredit: this.getInvoiceCredit.bind(this),
          },
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
      ],
      customerColumnDefs3: [
        {
          headerName: "متن پيام",
          field: "text",
          sortable: true,
          filter: false,
          resizable: false,
          wrapText: true,
          autoHeight: true,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
            maxWidth: "400px",
          },
          lockPosition: true,
        },
        {
          headerName: "وضعيت پيام",
          field: "status",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "شماره فاکتور",
          field: "invoiceId",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "متن خطا",
          field: "errorMessage",
          sortable: true,
          filter: false,
          resizable: false,
          wrapText: true,
          autoHeight: true,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
            maxWidth: "400px",
          },
          lockPosition: true,
        },
        {
          headerName: "تاريخ ملزم به ارسال",
          field: "persianMustSendOn",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تاريخ ارسال",
          field: "persianSendDate",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تاريخ ایجاد",
          field: "persianCreatedOn",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
      ],
      customerColumnDefs4: [
        {
          headerName: "شماره فاکتور",
          field: "invoiceForeignId",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "کد تخفيف",
          field: "discountCode",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "اعتبار استفاده شده",
          field: "usedCredit",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تاریخ ایجاد",
          field: "persianCreatedOn",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
      ],
      detailRowData: [],
      detailColumnDefs: [],
      detailColumnDefs1: [
        {
          headerName: "نام",
          field: "name",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "قیمت",
          field: "price",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تعداد",
          field: "quantity",
          cellRenderer: "formatNumber",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "قیمت کل",
          field: "totalPrice",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
      ],
      detailColumnDefs2: [
        {
          headerName: "نام اعتبار",
          field: "name",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "مبلغ دریافتی اعتبار",
          field: "credit",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "مبلغ استفاده شده اعتبار",
          field: "usedCredit",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تاریخ انقضا",
          field: "persianExpireDate",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
      ],
      TotalCreditsCount: 0,
      CurrentCredit: 0,
      GetCredit: 0,
      UsedCredit: 0,
      ExpireCredit: 0,
      showCustomerExtraInfo: false,
      ModalShow: false,
      writingProgress: false,
      dataLoading: true,
      currentPage: 0,
      totalPages: 0,
      currentPage1: 0,
      totalPages1: 0,
      currentPage2: 0,
      totalPages2: 0,
      currentPage3: 0,
      totalPages3: 0,
      chartData: [],
      argumentField: "title",
      valueField: "value",
      chartContainerWidth: 0,
      chartContainerHeight: 0,
      CreditCountParticipant: 0,
      CreditAmountParticipant: 0,
      TotalExpireAmount: 0,
      justTableLoading: false,
      CNameErrorText: "",
      CNameValue: "",
      CPhoneErrorText: "",
      CPhoneValue: "",
      minCreditErrorText: "",
      minCreditValue: "",
      maxCreditErrorText: "",
      maxCreditValue: "",
      ModalShow2: false,
      selectedGroupList: [],
      groupList: [],
      groupListLoading: false,
      tableHasFilter: false,
      ModalShow3: false,
      reportTitle: "",
      detailReportTitle: "",
      modal3Loading: false,
      currentAccountId: null,
      ModalShow4: false,
      Questions: [],
      thisWidth: 0,
      thisHeight: 0,
      currentRestaurantId: null,
      invoicesRowData: [],
      invoicesColumnDefs: [
        {
          headerName: "شماره فاکتور",
          field: "foreignId",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تاريخ ايجاد فاکتور",
          field: "persianInvoiceCreatedOn",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "نام مشتری",
          field: "accountName",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "موبایل مشتری",
          field: "accountPhone",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "نوع سرویس",
          field: "serviceTypeId",
          cellRenderer: "formatServiceName",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "مبلغ فاکتور",
          field: "totalPrice",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "مبلغ تخفيف",
          field: "discount",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "ابطال شده",
          field: "isDeleted",
          cellRenderer: "formatBool",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تخفیف به شرط خرید",
          field: "hasRuleDiscount",
          cellRenderer: "formatBool",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تخفيف نظرسنجی",
          field: "hasPollDiscount",
          cellRenderer: "formatBool",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
      ],

      smsRowData: [],
      smsColumnDefs: [
        {
          headerName: "متن پيام",
          field: "text",
          sortable: true,
          filter: false,
          resizable: false,
          wrapText: true,
          autoHeight: true,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
            maxWidth: "400px",
          },
          lockPosition: true,
        },
        {
          headerName: "موبایل",
          field: "phone",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "وضعيت پيام",
          field: "status",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "متن خطا",
          cellRenderer: "formatTextContent",
          field: "errorMessage",
          sortable: true,
          filter: false,
          resizable: false,
          wrapText: true,
          autoHeight: true,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
            maxWidth: "400px",
          },
          lockPosition: true,
        },
        {
          headerName: "زمان تنظیم شده برای ارسال",
          field: "persianMustSendOn",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "زمان ارسال",
          field: "persianSendDate",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تاریخ ایجاد",
          field: "persianCreatedOn",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
      ],
      priceUnit: "",
      dateValue1: moment().add(-1, "jMonth").format("jYYYY/jMM/jDD"),
      maxDateStart: moment().add(-1, "jDays").format("jYYYY/jMM/jDD"),
      dateValue2: moment().format("jYYYY/jMM/jDD"),
      maxDate: moment().add(0, "jDays").format("jYYYY/jMM/jDD"),
      minDate: null,
      ExcelDateModal: false,
      excelProgress: false,
      excelMode: 1,
    };

    this.datepicker1 = React.createRef();
    this.datepicker2 = React.createRef();

    this.tableContainer = React.createRef();
    this.tableContainer1 = React.createRef();
    this.tableContainer2 = React.createRef();
    this.tableContainer3 = React.createRef();
    this.tableContainer4 = React.createRef();
    this.chartContainer = React.createRef();
    this.chartRef = React.createRef();

    this.GetTotalCreditOverview = this.GetTotalCreditOverview.bind(this);
    this.textHandleChange = this.textHandleChange.bind(this);
    this.resetModalValues = this.resetModalValues.bind(this);
    this.GetAccounts = this.GetAccounts.bind(this);
    this.GetPolls = this.GetPolls.bind(this);
    this.GetInvoices = this.GetInvoices.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  formatNumber(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "0";
      return (
        <NumericFormat
          value={params.value}
          displayType={"text"}
          thousandSeparator={true}
        />
      );
    } catch (error) {
      return "-";
    }
  }

  formatCurrency(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "-";
      return (
        <NumericFormat
          value={params.value}
          displayType={"text"}
          thousandSeparator={true}
          suffix={" " + this.state.priceUnit}
        />
      );
    } catch (error) {
      return "-";
    }
  }

  formatBool(params) {
    try {
      if (params.value) {
        return "✔";
      } else return "🗙";
    } catch (error) {
      return "🗙";
    }
  }

  formatServiceName(params) {
    if (
      params.value === "null" ||
      params.value === "" ||
      params.value === 0 ||
      params.value === null
    )
      return "-";
    else {
      if (params.value.toString() === "0") return "داخلی";
      if (params.value.toString() === "1") return "بسته بندی";
      if (params.value.toString() === "2") return "ارسال";
      else return "-";
    }
  }

  formatDowngradeContent(params) {
    if (params.value) return "دارد";
    else return "ندارد";
  }

  fotmatEditCell(params) {
    return;
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    try {
      window.setTimeout(() => {
        let h = this.chartContainer.current.getBoundingClientRect().height;
        let w = this.chartContainer.current.getBoundingClientRect().width;

        this.setState(
          {
            chartContainerWidth: w,
            chartContainerHeight: h,
            thisWidth: window.innerWidth,
            thisHeight: window.innerHeight,
          },
          () => {
            if (this.chartRef.current) this.chartRef.current.instance.render();
          }
        );
      }, 10);
    } catch (error) {}
  }

  fixNumber(str) {
    var persianNumbers = [
        /۰/g,
        /۱/g,
        /۲/g,
        /۳/g,
        /۴/g,
        /۵/g,
        /۶/g,
        /۷/g,
        /۸/g,
        /۹/g,
      ],
      arabicNumbers = [
        /٠/g,
        /١/g,
        /٢/g,
        /٣/g,
        /٤/g,
        /٥/g,
        /٦/g,
        /٧/g,
        /٨/g,
        /٩/g,
      ];
    if (typeof str === "string") {
      for (var i = 0; i < 10; i++) {
        str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
      }
    }
    return str;
  }

  GetAccountsExcel() {
    let date1 = "";
    let date2 = "";

    date1 = moment(this.state.dateValue1, "jYYYY/jMM/jDD").format("YYYY-MM-DD");
    date2 = moment(this.state.dateValue2, "jYYYY/jMM/jDD").format("YYYY-MM-DD");

    let filter = new URLSearchParams({
      restaurantId: this.state.currentRestaurantId,
      name: this.state.CNameValue ? this.state.CNameValue : "",
      phone: this.state.CPhoneValue ? this.state.CPhoneValue : "",
      minCredit: this.state.minCreditValue ? this.state.minCreditValue : "",
      maxCredit: this.state.maxCreditValue ? this.state.maxCreditValue : "",
      groupsName: this.state.groupCNameValue ? this.state.groupCNameValue : "",
      fromDate: date1 + " 00:00:00",
      toDate: date2 + " 23:59:59",
    });

    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    this.setState({ excelProgress: true });
    fetch("https://94.101.187.196/api/Report/GetAccountsExcel?" + filter, {
      method: "GET",
      headers: { Authorization: jsonString },
    })
      .then((res) => {
        if (res.status !== 200) {
          return res.json();
        }
        return res.body;
      })
      .then((result) => {
        if (result.errorMessage) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          return null;
        } else {
          return result;
        }
      })
      .then((stream) => new Response(stream))
      .then((response) => response.blob())
      .then((blob) => {
        if (blob.size === 0) {
          return null;
        }
        return URL.createObjectURL(blob);
      })
      .then((url) => {
        this.setState({ excelProgress: false });
        if (!url) return;
        const link = document.createElement("a");
        link.href = url;
        link.download =
          "Accounts_" +
          moment(this.state.dateValue1, "jYYYY/jMM/jDD").format(
            "jYYYY-jMM-jDD"
          ) +
          "_" +
          moment(this.state.dateValue2, "jYYYY/jMM/jDD").format(
            "jYYYY-jMM-jDD"
          ) +
          ".xlsx";
        document.body.appendChild(link);
        link.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        );
        document.body.removeChild(link);
      })
      .catch((err) => {
        this.setState({ excelProgress: false });
        console.log(err);
        toast.error(err.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 8000,
          toastClassName: "toast",
        });
      });
  }

  GetSMSesExcel() {
    let date1 = "";
    let date2 = "";

    date1 = moment(this.state.dateValue1, "jYYYY/jMM/jDD").format("YYYY-MM-DD");
    date2 = moment(this.state.dateValue2, "jYYYY/jMM/jDD").format("YYYY-MM-DD");

    let filter = new URLSearchParams({
      restaurantId: this.state.currentRestaurantId,
      fromDate: date1 + " 00:00:00",
      toDate: date2 + " 23:59:59",
    });

    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    this.setState({ excelProgress: true });
    fetch("https://94.101.187.196/api/Report/GetSMSesExcel?" + filter, {
      method: "GET",
      headers: { Authorization: jsonString },
    })
      .then((res) => {
        if (res.status !== 200) {
          return res.json();
        }
        return res.body;
      })
      .then((result) => {
        if (result.errorMessage) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          return null;
        } else {
          return result;
        }
      })
      .then((stream) => new Response(stream))
      .then((response) => response.blob())
      .then((blob) => {
        if (blob.size === 0) {
          return null;
        }
        return URL.createObjectURL(blob);
      })
      .then((url) => {
        this.setState({ excelProgress: false });
        if (!url) return;
        const link = document.createElement("a");
        link.href = url;
        link.download =
          "SMSReport_" +
          moment(this.state.dateValue1, "jYYYY/jMM/jDD").format(
            "jYYYY-jMM-jDD"
          ) +
          "_" +
          moment(this.state.dateValue2, "jYYYY/jMM/jDD").format(
            "jYYYY-jMM-jDD"
          ) +
          ".xlsx";
        document.body.appendChild(link);
        link.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        );
        document.body.removeChild(link);
      })
      .catch((err) => {
        this.setState({ excelProgress: false });
        // console.log(err);
        toast.error(err.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 8000,
          toastClassName: "toast",
        });
      });
  }

  dateChange1(dateValue) {
    try {
      this.datepicker1.current.closeCalendar();
      this.datepicker2.current.closeCalendar();
    } catch (error) {}
    let value = this.fixNumber(new DateObject(dateValue).format("YYYY/MM/DD"));
    this.setState({ dateValue1: value, minDate: value });
  }

  dateChange2(dateValue) {
    try {
      this.datepicker1.current.closeCalendar();
      this.datepicker2.current.closeCalendar();
    } catch (error) {}

    let value = this.fixNumber(new DateObject(dateValue).format("YYYY/MM/DD"));
    this.setState({ dateValue2: value, minDate: value });
  }

  getBusinessInfo() {
    let data = {
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "findBusinessWithCode", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        // console.log(result);
        if (result.status === 200) {
          this.setState(
            {
              currentRestaurantId: result.result[0].id,
              priceUnit: result.result[0].rtlPriceTitle,
            },
            () => {
              this.GetAccounts(1, null, null, null, null, null, true);
            }
          );
        } else if (result.status === 401) {
          LogoutFunction();
        }
        // console.log("findBusinessWithCode:", result);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  componentDidMount() {
    // alert(window.innerHeight*0.2)

    window.addEventListener("resize", this.updateWindowDimensions);
    this.updateWindowDimensions();

    // this.GetAccounts(1, null, null, null, null, null, true);

    this.getBusinessInfo();
  }

  GetAccounts(page, name, phone, minCredit, maxCredit, groupsName, firstUse) {
    let txtFilter = "";
    if (name) txtFilter += "&name=" + name;
    if (phone) txtFilter += "&phone=" + phone;
    if (minCredit && Number(minCredit) > 0)
      txtFilter += "&minCredit=" + minCredit;
    if (maxCredit && Number(minCredit) > 0)
      txtFilter += "&maxCredit=" + maxCredit;
    if (groupsName) txtFilter += "&groupsName=" + groupsName;
    if (firstUse) this.setState({ dataLoading: true });
    else this.setState({ justTableLoading: true });

    let hasFilter = false;
    if (txtFilter) hasFilter = true;

    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));
    console.log(data);
    fetch(
      "https://94.101.187.196/api/Report/GetAccounts?restaurantId=" +
        this.state.currentRestaurantId +
        "&page=" +
        page +
        txtFilter,
      {
        method: "GET",
        headers: { Authorization: jsonString },
      }
    )
      .then((res) => {
        if (res.status === 401) {
          // LogoutFunction();
        } else {
          return res.json();
        }
      })
      .then((result) => {
        console.log("GetAccounts: ", result);
        // if (result.isSuccessfull){

        // }else {
        //     this.props.history.push('/Restaurants');
        // }

        if (!result.isSuccessfull) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }

        this.setState(
          {
            rowData: result.results[0].items,
            currentPage: result.results[0].currentPage,
            totalPages: result.results[0].totalPages,
            tableHasFilter: hasFilter,
          },
          () => {
            if (firstUse) this.GetPolls();
            else this.setState({ justTableLoading: false });
          }
        );
      })
      .catch((err) => {
        console.log(err);
        this.setState({ dataLoading: false, justTableLoading: false });
      });
  }

  GetPolls() {
    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    fetch("https://94.101.187.196/api/Poll/GetPolls", {
      method: "GET",
      headers: { Authorization: jsonString },
    })
      .then((res) => {
        // console.log(res);
        if (res.status === 401) {
          LogoutFunction();
        } else {
          return res.json();
        }
      })
      .then((result) => {
        // console.log("GetPolls", result.results);
        this.setState({ Questions: result.results }, () => {
          // this.GetTotalCreditOverview();
          this.GetInvoices(1, true);
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ dataLoading: false, justTableLoading: false });
      });
  }

  GetInvoices(page, firstUse) {
    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));
    console.log(data);
    console.log(jsonString);
    fetch(
      "https://94.101.187.196/api/Report/GetInvoices?restaurantId=" +
        this.state.currentRestaurantId +
        "&page=" +
        page,
      {
        method: "GET",
        headers: { Authorization: jsonString },
      }
    )
      .then((res) => {
        // console.log(res);
        if (res.status === 401) {
          localStorage.clear();
          this.props.history.push("/Login");
        } else {
          return res.json();
        }
      })
      .then((result) => {
        console.log(result);
        this.setState(
          {
            invoicesRowData:
              result.results[0].items.length > 0 ? result.results[0].items : [],
            currentPage2: result.results[0].currentPage,
            totalPages2: result.results[0].totalPages,
          },
          () => {
            if (firstUse) this.GetSMSes(1, true);
          }
        );
      })
      .catch((err) => {
        console.log(err);
        this.setState({ dataLoading: false, justTableLoading: false });
      });
  }

  GetSMSes(page, firstUse) {
    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    fetch(
      "https://94.101.187.196/api/Report/GetSMSes?restaurantId=" +
        this.state.currentRestaurantId +
        "&page=" +
        page,
      {
        method: "GET",
        headers: { Authorization: jsonString },
      }
    )
      .then((res) => {
        // console.log(res);
        if (res.status === 401) {
          localStorage.clear();
          this.props.history.push("/Login");
        } else {
          return res.json();
        }
      })
      .then((result) => {
        console.log(result);
        this.setState(
          {
            smsRowData:
              result.results[0].items.length > 0 ? result.results[0].items : [],
            currentPage3: result.results[0].currentPage,
            totalPages3: result.results[0].totalPages,
          },
          () => {
            if (firstUse) this.GetTotalCreditOverview();
          }
        );
      })
      .catch((err) => {
        console.log(err);
        this.setState({ dataLoading: false, justTableLoading: false });
      });
  }

  GetTotalCreditOverview() {
    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    this.setState({ dataLoading: true });
    fetch(
      "https://94.101.187.196/api/Report/GetTotalCreditOverview?restaurantId=" +
        this.state.currentRestaurantId,
      {
        method: "GET",
        headers: { Authorization: jsonString },
      }
    )
      .then((res) => {
        if (res.status === 401) {
          LogoutFunction();
        } else {
          return res.json();
        }
      })
      .then((result) => {
        console.log(result);
        // if (result.isSuccessfull){

        // }else {
        //     this.props.history.push('/Restaurants');
        // }

        if (!result.isSuccessfull) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }

        let val1 = {
          title: "اعتبارهای استفاده شده",
          value: result.results[0].totalUsedCreditCount,
          amount: result.results[0].totalUsedCreditAmount,
        };

        let val2 = {
          title: "اعتبارهای استفاده نشده",
          value:
            result.results[0].totalCreditCount -
            result.results[0].totalUsedCreditCount,
          amount:
            result.results[0].totalCreditAmount -
            result.results[0].totalUsedCreditAmount,
        };

        let chartdata = [val1, val2];
        console.log(chartdata);
        this.setState({ dataLoading: false, chartData: chartdata }, () => {
          this.setState(
            {
              CreditAmountParticipant:
                result.results[0].creditAmountParticipant,
              CreditCountParticipant: result.results[0].creditCountParticipant,
              TotalExpireAmount: result.results[0].totalExpireAmount,
            },
            () => {
              this.updateWindowDimensions();
            }
          );
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ dataLoading: false });
      });
  }

  GetCreditsOfAccount(id, page) {
    this.setState({ ModalShow3: true, modal3Loading: true });

    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    fetch(
      "https://94.101.187.196/api/Report/GetCreditsOfAccount?accountId=" +
        id +
        "&page=" +
        page,
      {
        method: "GET",
        headers: { Authorization: jsonString },
      }
    )
      .then((res) => {
        if (res.status === 401) {
          LogoutFunction();
        } else {
          return res.json();
        }
      })
      .then((result) => {
        console.log(result);
        // if (result.isSuccessfull){

        // }else {
        //     this.props.history.push('/Restaurants');
        // }

        if (!result.isSuccessfull) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }

        this.setState({
          modal3Loading: false,
          showCustomerExtraInfo: true,
          currentTableIndex: 0,
          reportTitle: "اعتبارهای دريافتی مشترک",
          customerColumnDefs: this.state.customerColumnDefs1,
          customerRowData: result.results[0].items,
          TotalCreditsCount: result.results[0].totalCreditsCount,
          CurrentCredit: result.results[0].currentCredit,
          GetCredit: result.results[0].getCredit,
          UsedCredit: result.results[0].usedCredit,
          ExpireCredit: result.results[0].expireCredit,
          currentAccountId: id,
          currentPage1: result.results[0].currentPage,
          totalPages1: result.results[0].totalPages,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ dataLoading: false });
      });
  }

  GetInvoicesOfAccount(id, page) {
    this.setState({ ModalShow3: true, modal3Loading: true });

    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    fetch(
      "https://94.101.187.196/api/Report/GetInvoicesOfAccount?accountId=" +
        id +
        "&page=" +
        page,
      {
        method: "GET",
        headers: { Authorization: jsonString },
      }
    )
      .then((res) => {
        if (res.status === 401) {
          LogoutFunction();
        } else {
          return res.json();
        }
      })
      .then((result) => {
        // console.log(result);
        // if (result.isSuccessfull){

        // }else {
        //     this.props.history.push('/Restaurants');
        // }

        if (!result.isSuccessfull) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }

        this.setState({
          modal3Loading: false,
          showCustomerExtraInfo: false,
          currentTableIndex: 1,
          reportTitle: "ليست خريدهای مشترک",
          customerColumnDefs: this.state.customerColumnDefs2,
          customerRowData: result.results[0].items,
          currentAccountId: id,
          currentPage1: result.results[0].currentPage,
          totalPages1: result.results[0].totalPages,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ dataLoading: false });
      });
  }

  GetSMSesOfAccount(id, page) {
    this.setState({ ModalShow3: true, modal3Loading: true });

    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    fetch(
      "https://94.101.187.196/api/Report/GetSMSesOfAccount?accountId=" +
        id +
        "&page=" +
        page,
      {
        method: "GET",
        headers: { Authorization: jsonString },
      }
    )
      .then((res) => {
        if (res.status === 401) {
          LogoutFunction();
        } else {
          return res.json();
        }
      })
      .then((result) => {
        console.log(result);
        // if (result.isSuccessfull){

        // }else {
        //     this.props.history.push('/Restaurants');
        // }

        if (!result.isSuccessfull) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }

        this.setState({
          modal3Loading: false,
          showCustomerExtraInfo: false,
          currentTableIndex: 2,
          reportTitle: "پيام‌های ارسالی",
          customerColumnDefs: this.state.customerColumnDefs3,
          customerRowData: result.results[0].items,
          currentAccountId: id,
          currentPage1: result.results[0].currentPage,
          totalPages1: result.results[0].totalPages,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ dataLoading: false });
      });
  }

  GetDiscountHistoryOfAccount(id, page) {
    this.setState({ ModalShow3: true, modal3Loading: true });

    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    fetch(
      "https://94.101.187.196/api/Report/GetDiscountHistoryOfAccount?accountId=" +
        id +
        "&page=" +
        page,
      {
        method: "GET",
        headers: { Authorization: jsonString },
      }
    )
      .then((res) => {
        if (res.status === 401) {
          LogoutFunction();
        } else {
          return res.json();
        }
      })
      .then((result) => {
        // console.log(result);
        // if (result.isSuccessfull){

        // }else {
        //     this.props.history.push('/Restaurants');
        // }

        if (!result.isSuccessfull) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }

        this.setState({
          modal3Loading: false,
          showCustomerExtraInfo: false,
          currentTableIndex: 3,
          reportTitle: "گزارش استفاده از اعتبار مشترک",
          customerColumnDefs: this.state.customerColumnDefs4,
          customerRowData: result.results[0].items,
          currentAccountId: id,
          currentPage1: result.results[0].currentPage,
          totalPages1: result.results[0].totalPages,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ dataLoading: false });
      });
  }

  getInvoiceDetail(id) {
    let rowdata = [];
    this.state.customerRowData.forEach((element) => {
      if (element.foreignId === id && element.invoiceCreditDatas !== null) {
        rowdata = element.invoiceDetailOfAccountDatas;
      }
    });
    this.setState({
      ModalShow4: true,
      detailReportTitle: "جزئیات خرید",
      detailColumnDefs: this.state.detailColumnDefs1,
      detailRowData: rowdata,
    });
  }

  getInvoiceCredit(id) {
    let rowdata = [];
    this.state.customerRowData.forEach((element) => {
      if (element.foreignId === id && element.invoiceCreditDatas !== null) {
        rowdata = element.invoiceCreditDatas;
      }
    });
    console.log(rowdata);
    this.setState({
      ModalShow4: true,
      detailReportTitle: "جزئیات اعتبار",
      detailColumnDefs: this.state.detailColumnDefs2,
      detailRowData: rowdata,
    });
  }

  onFirstPageClick() {
    this.GetAccounts(
      1,
      this.state.CNameValue,
      this.state.CPhoneValue,
      this.state.minCreditValue,
      this.state.maxCreditValue,
      this.state.groupCNameValue,
      false
    );
  }

  onPreviousPageClick() {
    this.GetAccounts(
      this.state.currentPage - 1,
      this.state.CNameValue,
      this.state.CPhoneValue,
      this.state.minCreditValue,
      this.state.maxCreditValue,
      this.state.groupCNameValue,
      false
    );
  }

  onNextPageClick() {
    this.GetAccounts(
      this.state.currentPage + 1,
      this.state.CNameValue,
      this.state.CPhoneValue,
      this.state.minCreditValue,
      this.state.maxCreditValue,
      this.state.groupCNameValue,
      false
    );
  }

  onLastPageClick() {
    this.GetAccounts(
      this.state.totalPages,
      this.state.CNameValue,
      this.state.CPhoneValue,
      this.state.minCreditValue,
      this.state.maxCreditValue,
      this.state.groupCNameValue,
      false
    );
  }

  onFirstPageClick1() {
    switch (this.state.currentTableIndex) {
      case 0: {
        this.GetCreditsOfAccount(this.state.currentAccountId, 1);
        break;
      }
      case 1: {
        this.GetInvoicesOfAccount(this.state.currentAccountId, 1);
        break;
      }
      case 2: {
        this.GetSMSesOfAccount(this.state.currentAccountId, 1);
        break;
      }
      case 3: {
        this.GetDiscountHistoryOfAccount(this.state.currentAccountId, 1);
        break;
      }

      default:
        break;
    }
  }

  onPreviousPageClick1() {
    switch (this.state.currentTableIndex) {
      case 0: {
        this.GetCreditsOfAccount(
          this.state.currentAccountId,
          this.state.currentPage1 - 1
        );
        break;
      }
      case 1: {
        this.GetInvoicesOfAccount(
          this.state.currentAccountId,
          this.state.currentPage1 - 1
        );
        break;
      }
      case 2: {
        this.GetSMSesOfAccount(
          this.state.currentAccountId,
          this.state.currentPage1 - 1
        );
        break;
      }
      case 3: {
        this.GetDiscountHistoryOfAccount(
          this.state.currentAccountId,
          this.state.currentPage1 - 1
        );
        break;
      }
      default:
        break;
    }
  }

  onNextPageClick1() {
    switch (this.state.currentTableIndex) {
      case 0: {
        this.GetCreditsOfAccount(
          this.state.currentAccountId,
          this.state.currentPage1 + 1
        );
        break;
      }
      case 1: {
        this.GetInvoicesOfAccount(
          this.state.currentAccountId,
          this.state.currentPage1 + 1
        );
        break;
      }
      case 2: {
        this.GetSMSesOfAccount(
          this.state.currentAccountId,
          this.state.currentPage1 + 1
        );
        break;
      }
      case 3: {
        this.GetDiscountHistoryOfAccount(
          this.state.currentAccountId,
          this.state.currentPage1 + 1
        );
        break;
      }
      default:
        break;
    }
  }

  onLastPageClick1() {
    switch (this.state.currentTableIndex) {
      case 0: {
        this.GetCreditsOfAccount(
          this.state.currentAccountId,
          this.state.totalPages1
        );
        break;
      }
      case 1: {
        this.GetInvoicesOfAccount(
          this.state.currentAccountId,
          this.state.totalPages1
        );
        break;
      }
      case 2: {
        this.GetSMSesOfAccount(
          this.state.currentAccountId,
          this.state.totalPages1
        );
        break;
      }
      case 3: {
        this.GetDiscountHistoryOfAccount(
          this.state.currentAccountId,
          this.state.totalPages1
        );
        break;
      }
      default:
        break;
    }
  }

  onFirstPageClick2() {
    this.GetInvoices(1, false);
  }

  onPreviousPageClick2() {
    this.GetInvoices(this.state.currentPage2 - 1, false);
  }

  onNextPageClick2() {
    this.GetInvoices(this.state.currentPage2 + 1, false);
  }

  onLastPageClick2() {
    this.GetInvoices(this.state.totalPages2, false);
  }

  onFirstPageClick3() {
    this.GetSmSes(1, false);
  }

  onPreviousPageClick3() {
    this.GetSmSes(this.state.currentPage3 - 1, false);
  }

  onNextPageClick3() {
    this.GetSmSes(this.state.currentPage3 + 1, false);
  }

  onLastPageClick3() {
    this.GetSmSes(this.state.totalPages3, false);
  }

  onBack() {
    this.props.history.push(
      "/Restaurants/" + this.props.match.params.id + "/Club"
    );
  }

  onLogout() {
    LogoutFunction();
  }

  onFirstDataRendered(params) {
    try {
      params.api.sizeColumnsToFit();
      window.setTimeout(() => {
        const colIds = params.columnApi.getAllColumns().map((c) => c.colId);
        params.columnApi.autoSizeColumns(colIds, false);

        let cols = params.columnApi.getColumnState();
        let width = 0;
        cols.forEach((element) => {
          width += element.width;
        });

        if (
          width <
          this.tableContainer.current.getBoundingClientRect().width - 10
        ) {
          let def =
            this.tableContainer.current.getBoundingClientRect().width -
            10 -
            width;
          if (def > cols.length) {
            let newwidth = def / cols.length;
            cols.forEach((element) => {
              params.columnApi.setColumnWidth(
                element.colId,
                element.width + newwidth
              );
            });
            // params.columnApi.setColumnWidth(cols[0].colId,cols[0].width-1)
            // params.columnApi.setColumnWidth(cols[cols.length-1].colId,cols[cols.length-1].width+1)
          } else {
            params.columnApi.setColumnWidth(cols[0].colId, cols[0].width + def);
          }
        }
      }, 50);
    } catch (error) {}
  }

  onFirstDataRendered1(params) {
    try {
      params.api.sizeColumnsToFit();
      window.setTimeout(() => {
        const colIds = params.columnApi.getAllColumns().map((c) => c.colId);
        params.columnApi.autoSizeColumns(colIds, false);

        let cols = params.columnApi.getColumnState();
        let width = 0;
        cols.forEach((element) => {
          width += element.width;
        });

        if (
          width <
          this.tableContainer1.current.getBoundingClientRect().width - 10
        ) {
          let def =
            this.tableContainer1.current.getBoundingClientRect().width -
            10 -
            width;
          if (def > cols.length) {
            let newwidth = def / cols.length;
            cols.forEach((element) => {
              params.columnApi.setColumnWidth(
                element.colId,
                element.width + newwidth
              );
            });
          } else {
            params.columnApi.setColumnWidth(cols[0].colId, cols[0].width + def);
          }
        }
      }, 50);
    } catch (error) {}
  }

  onFirstDataRendered2(params) {
    try {
      params.api.sizeColumnsToFit();
      window.setTimeout(() => {
        const colIds = params.columnApi.getAllColumns().map((c) => c.colId);
        params.columnApi.autoSizeColumns(colIds, false);

        let cols = params.columnApi.getColumnState();
        let width = 0;
        cols.forEach((element) => {
          width += element.width;
        });

        if (
          width <
          this.tableContainer2.current.getBoundingClientRect().width - 10
        ) {
          let def =
            this.tableContainer2.current.getBoundingClientRect().width -
            10 -
            width;
          if (def > cols.length) {
            let newwidth = def / cols.length;
            cols.forEach((element) => {
              params.columnApi.setColumnWidth(
                element.colId,
                element.width + newwidth
              );
            });
          } else {
            params.columnApi.setColumnWidth(cols[0].colId, cols[0].width + def);
          }
        }
      }, 50);
    } catch (error) {}
  }

  onFirstDataRendered3(params) {
    try {
      params.api.sizeColumnsToFit();
      window.setTimeout(() => {
        const colIds = params.columnApi.getAllColumns().map((c) => c.colId);
        params.columnApi.autoSizeColumns(colIds, false);

        let cols = params.columnApi.getColumnState();
        let width = 0;
        cols.forEach((element) => {
          width += element.width;
        });

        if (
          width <
          this.tableContainer3.current.getBoundingClientRect().width - 10
        ) {
          let def =
            this.tableContainer3.current.getBoundingClientRect().width -
            10 -
            width;
          if (def > cols.length) {
            let newwidth = def / cols.length;
            cols.forEach((element) => {
              params.columnApi.setColumnWidth(
                element.colId,
                element.width + newwidth
              );
            });
          } else {
            params.columnApi.setColumnWidth(cols[0].colId, cols[0].width + def);
          }
        }
      }, 50);
    } catch (error) {}
  }

  onFirstDataRendered4(params) {
    try {
      params.api.sizeColumnsToFit();
      window.setTimeout(() => {
        const colIds = params.columnApi.getAllColumns().map((c) => c.colId);
        params.columnApi.autoSizeColumns(colIds, false);

        let cols = params.columnApi.getColumnState();
        let width = 0;
        cols.forEach((element) => {
          width += element.width;
        });

        if (
          width <
          this.tableContainer4.current.getBoundingClientRect().width - 10
        ) {
          let def =
            this.tableContainer4.current.getBoundingClientRect().width -
            10 -
            width;
          if (def > cols.length) {
            let newwidth = def / cols.length;
            cols.forEach((element) => {
              params.columnApi.setColumnWidth(
                element.colId,
                element.width + newwidth
              );
            });
          } else {
            params.columnApi.setColumnWidth(cols[0].colId, cols[0].width + def);
          }
        }
      }, 50);
    } catch (error) {}
  }

  resetModalValues() {
    this.setState({
      CNameErrorText: "",
      CNameValue: "",
      CPhoneErrorText: "",
      CPhoneValue: "",
      minCreditErrorText: "",
      minCreditValue: "",
      maxCreditErrorText: "",
      maxCreditValue: "",
    });
  }

  hideModal() {
    this.setState({ ModalShow: false });
  }

  textHandleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  onConfirm() {
    if (this.state.CPhoneValue && !mobileRegex.test(this.state.CPhoneValue)) {
      this.setState({ CPhoneErrorText: "شماره موبایل نامعتبر است" }, () => {
        toast.error(this.state.CPhoneErrorText, {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 8000,
          toastClassName: "toast",
        });
      });
      return;
    } else {
      this.setState({ CPhoneErrorText: "" });
    }

    if (
      this.state.minCreditValue &&
      this.state.maxCreditValue &&
      Number(this.state.minCreditValue) > Number(this.state.maxCreditValue)
    ) {
      this.setState(
        {
          minCreditErrorText:
            "حداقل اعتبار نمی‌تواند از حداکثر اعتبار بیشتر باشد",
        },
        () => {
          toast.error(this.state.minCreditErrorText, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
      );
      return;
    } else {
      this.setState({ minCreditErrorText: "" });
    }

    let groupName = "";
    this.state.selectedGroupList.forEach((element) => {
      this.state.groupList.forEach((element1) => {
        if (element === element1.id) {
          if (groupName === "") groupName = element1.name;
          else groupName += "," + element1.name;
        }
      });
    });

    this.setState({ ModalShow: false });
    this.GetAccounts(
      1,
      this.state.CNameValue,
      this.state.CPhoneValue,
      this.state.minCreditValue,
      this.state.maxCreditValue,
      groupName,
      false
    );
  }

  creditValue(params) {
    let result =
      params.value.toString() +
      " عدد (" +
      params.point.data.amount
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
      " )" +
      this.state.priceUnit +
      " (" +
      params.percentText.toString() +
      ")";
    return result;
  }

  onFilterClick() {
    this.setState({ ModalShow: true });
  }

  onCustomerGroupsClick() {
    this.setState({ ModalShow2: true, groupListLoading: true });

    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    console.log("data: ", data);
    console.log(jsonString);

    fetch(
      "https://94.101.187.196/api/AccountGroup/GetAccountGroups?restaurantId=" +
        this.state.currentRestaurantId +
        "&page=0",
      {
        method: "GET",
        headers: { Authorization: jsonString },
      }
    )
      .then((res) => {
        if (res.status === 401) {
          LogoutFunction();
        } else {
          return res.json();
        }
      })
      .then((result) => {
        console.log("kkkkkk: ", result);
        if (!result.isSuccessfull) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }

        this.setState({
          groupListLoading: false,
          groupList: result.results[0].items,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ groupListLoading: false });
      });
  }

  hideModal2() {
    this.setState({ ModalShow2: false });
  }

  hideModal3() {
    this.setState({ ModalShow3: false });
  }

  hideModal4() {
    this.setState({ ModalShow4: false });
  }

  onConfirmGroups(list) {
    this.setState({ selectedGroupList: list, ModalShow2: false });
  }

  onFilterClear() {
    this.resetModalValues();
    this.GetAccounts(1, null, null, null, null, null, false);
  }

  onSuspectBlockClick() {
    this.props.onGoToSuspectsOrBlocks(this.props.match.params.id);
  }

  render() {
    return (
      <div className="Login">
        <div className="header">
          <div
            onClick={this.onBack.bind(this)}
            className="linkStyle backButton"
          >
            <img
              src={Back}
              alt=""
              className="backButtonIcon"
              style={{ transform: "rotate(180deg)" }}
            />
            بازگشت
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              height: "fit-content",
              alignItems: "center",
            }}
          >
            <Tooltip title="خروج">
              <div
                onClick={this.onLogout.bind(this)}
                className="linkStyle backButton"
              >
                <img src={Logout} alt="" className="backButtonIcon" />
              </div>
            </Tooltip>
          </div>
        </div>
        <div className="LoginContent">
          <div className="RestaurantsListTitle">گزارشات</div>
          <div className="RestaurantsListSubTitle">
            گزارش مالی و لیست مشترکین رستوران
          </div>
        </div>

        {this.state.dataLoading && (
          <div
            style={{
              display: "flex",
              width: "100vw",
              maxWidth: "1200px",
              height: "75vh",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <WhisperSpinner
              size={50}
              color="var(--brown1)"
              frontColor="var(--brown1)"
              backColor="var(--brown1)"
              loading={true}
            />
          </div>
        )}

        <div
          className="reportContaner"
          style={{ visibility: this.state.dataLoading ? "hidden" : "visible" }}
          ref={this.chartContainer}
        >
          <div className="reportTitleBar">گزارش مالی رستوران</div>
          <div
            className="reportContent reportChart"
            style={{ backgroundColor: "var(--brown1)" }}
          >
            <div
              style={{
                flex: "1",
                width: this.state.thisWidth <= 587 ? "100%" : "65%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "20px",
                height: "100%",
              }}
            >
              <PieChart
                rtlEnabled
                id="pie"
                palette={["white", "#58341d"]}
                dataSource={this.state.chartData}
                ref={this.chartRef}
              >
                <Legend
                  orientation="horizontal"
                  itemTextPosition="left"
                  horizontalAlignment="center"
                  columnCount={1}
                  verticalAlignment="bottom"
                >
                  <Font color="white" family="SFUIDisplay" />
                </Legend>
                <Series argumentField="title" valueField="value">
                  <Label
                    visible={true}
                    backgroundColor={
                      !this.state.ModalShow ? undefined : "var(--brown1)"
                    }
                    customizeText={this.creditValue}
                    wordWrap="none"
                    textOverflow="none"
                  >
                    <Connector
                      visible={true}
                      width={1}
                      color={
                        !this.state.ModalShow ? undefined : "var(--brown1)"
                      }
                    />
                    <Font
                      color="var(--brown1)"
                      family="SFUIDisplay"
                      size={14}
                    />
                  </Label>
                  <SmallValuesGrouping
                    topCount={10}
                    mode="topN"
                    groupName="سایر"
                  />
                </Series>

                <Size
                  height={
                    this.state.thisWidth <= 587
                      ? this.state.chartContainerWidth * 0.95
                      : (this.state.chartContainerHeight - 120) * 0.98
                  }
                  width={
                    this.state.thisWidth <= 587
                      ? this.state.chartContainerWidth * 0.95
                      : this.state.chartContainerWidth * 0.65 * 0.95
                  }
                />
              </PieChart>
            </div>
            <div
              style={{
                width: this.state.thisWidth <= 587 ? "100%" : "35%",
                flexDirection: "column",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "20px",
                height: "100%",
              }}
            >
              {this.state.chartContainerHeight > 0 && (
                <div
                  style={{
                    flex: "1",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      height:
                        this.state.thisWidth <= 587
                          ? 160
                          : (this.state.chartContainerHeight - 250) / 3,
                      width:
                        this.state.thisWidth <= 587
                          ? 160
                          : (this.state.chartContainerHeight - 250) / 3,
                    }}
                  >
                    <CircularProgressbar
                      strokeWidth={15}
                      value={this.state.CreditCountParticipant}
                      text={`${this.state.CreditCountParticipant}%`}
                      styles={buildStyles({
                        textSize: "16px",
                        pathTransitionDuration: 2,
                        pathColor: "white",
                        textColor: "white",
                        trailColor: "#58341d",
                      })}
                    />
                  </div>

                  <div className="circularProgressContainerTitle">
                    درصد تعداد مشارکت
                  </div>
                </div>
              )}
              {this.state.chartContainerHeight > 0 && (
                <div
                  style={{
                    flex: "1",
                    marginTop: "20px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      height:
                        this.state.thisWidth <= 587
                          ? 160
                          : (this.state.chartContainerHeight - 250) / 3,
                      width:
                        this.state.thisWidth <= 587
                          ? 160
                          : (this.state.chartContainerHeight - 250) / 3,
                    }}
                  >
                    <CircularProgressbar
                      strokeWidth={15}
                      value={this.state.CreditCountParticipant}
                      text={`${this.state.CreditCountParticipant}%`}
                      styles={buildStyles({
                        textSize: "16px",
                        pathTransitionDuration: 2,
                        pathColor: "white",
                        textColor: "white",
                        trailColor: "#58341d",
                      })}
                    />
                  </div>
                  <div className="circularProgressContainerTitle">
                    درصد مبلغ مشارکت
                  </div>
                </div>
              )}
              {this.state.chartContainerHeight > 0 && (
                <div
                  className="singleInfo"
                  style={{
                    marginTop: "40px",
                    flex: "1",
                  }}
                >
                  <div style={{ marginLeft: "10px", marginBottom: "10px" }}>
                    مبلغ اعتبارهای منقضی شده:{" "}
                  </div>
                  <NumericFormat
                    className="singleInfoNumberValue"
                    value={this.state.TotalExpireAmount}
                    displayType={"text"}
                    thousandSeparator={true}
                    suffix={" " + this.state.priceUnit}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        {!this.state.dataLoading && (
          <div
            className="reportContaner"
            style={{ marginBottom: "100px", height: "unset" }}
          >
            <div className="reportTitleBar">گزارش مشترکین رستوران</div>
            <div
              className="reportContent"
              style={{ paddingTop: "10px", paddingBottom: "10px" }}
            >
              {!this.state.justTableLoading && (
                <div
                  className="pageContents"
                  style={{ marginTop: "0px" }}
                  ref={this.tableContainer}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <CustomButton
                        title="اعمال فیلتر"
                        whiteSpace="noWrap"
                        imgHeight={20}
                        imgWidth={25}
                        flexDirection="row-reverse"
                        minHeight="35px"
                        img={filter}
                        onClick={this.onFilterClick.bind(this)}
                      />
                      <div style={{ minWidth: "10px" }} />
                      {this.state.tableHasFilter && (
                        <CustomButton
                          title="حذف فیلترها"
                          whiteSpace="noWrap"
                          imgHeight={20}
                          imgWidth={25}
                          backColor="var(--red1)"
                          flexDirection="row-reverse"
                          minHeight="35px"
                          img={Cancel}
                          onClick={this.onFilterClear.bind(this)}
                        />
                      )}

                      <div style={{ minWidth: "10px" }} />
                      <CustomButton
                        title="خروجی اکسل"
                        whiteSpace="noWrap"
                        imgHeight={20}
                        imgWidth={25}
                        flexDirection="row-reverse"
                        minHeight="35px"
                        ico={fileExcel}
                        onClick={() => {
                          this.setState({ ExcelDateModal: true, excelMode: 1 });
                        }}
                      />
                    </div>
                    <div>
                      <CustomButton
                        title="تلفن‌های مشکوک و مسدود"
                        whiteSpace="noWrap"
                        imgHeight={28}
                        imgWidth={26}
                        flexDirection="row-reverse"
                        minHeight="35px"
                        img={blocklistwhite}
                        onClick={this.onSuspectBlockClick.bind(this)}
                      />
                    </div>
                  </div>
                  <div className="tableContainer ag-theme-alpine">
                    <AgGridReact
                      enableRtl={true}
                      autoHeight={true}
                      animateRows={true}
                      enableBrowserTooltips={true}
                      tooltipMouseTrack={true}
                      suppressSizeToFit={false}
                      columnDefs={this.state.columnDefs}
                      localeText={this.state.gridLocaleText}
                      rowData={this.state.rowData}
                      suppressDragLeaveHidesColumns={true}
                      suppressMovable={true}
                      skipHeaderOnAutoSize={false}
                      onFirstDataRendered={this.onFirstDataRendered.bind(this)}
                      rowHeight={window.innerWidth <= 587 ? 40 : 50}
                      headerHeight={window.innerWidth <= 587 ? 40 : 50}
                      frameworkComponents={this.state.frameworkComponents}
                      enableCellTextSelection={true}
                      ensureDomOrder={true}
                    ></AgGridReact>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginTop: "15px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Paginator
                      currentPage={this.state.currentPage}
                      totalPages={this.state.totalPages}
                      onFirstPageClick={this.onFirstPageClick.bind(this)}
                      onPreviousPageClick={this.onPreviousPageClick.bind(this)}
                      onNextPageClick={this.onNextPageClick.bind(this)}
                      onLastPageClick={this.onLastPageClick.bind(this)}
                    />
                  </div>
                </div>
              )}

              {this.state.justTableLoading && (
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    height: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <WhisperSpinner
                    size={30}
                    color="var(--brown1)"
                    frontColor="var(--brown1)"
                    backColor="var(--brown1)"
                    loading={true}
                  />
                </div>
              )}
            </div>
          </div>
        )}

        {!this.state.dataLoading && (
          <PollReports
            gridLocaleText={this.state.gridLocaleText}
            Questions={this.state.Questions}
            restaurantId={this.state.currentRestaurantId}
            thisSizeChangeW={this.state.thisWidth}
            thisSizeChangeH={this.state.thisHeight}
          />
        )}

        {!this.state.dataLoading && (
          <div
            className="reportContaner"
            style={{ marginBottom: "100px", height: "unset" }}
          >
            <div className="reportTitleBar">گزارش کلی فاکتورها</div>
            <div
              className="reportContent"
              style={{ paddingTop: "10px", paddingBottom: "10px" }}
            >
              <div
                className="pageContents"
                style={{ marginTop: "0px" }}
                ref={this.tableContainer3}
              >
                <div className="tableContainer ag-theme-alpine">
                  <AgGridReact
                    enableRtl={true}
                    autoHeight={true}
                    animateRows={true}
                    enableBrowserTooltips={true}
                    tooltipMouseTrack={true}
                    suppressSizeToFit={false}
                    columnDefs={this.state.invoicesColumnDefs}
                    localeText={this.state.gridLocaleText}
                    rowData={this.state.invoicesRowData}
                    suppressDragLeaveHidesColumns={true}
                    suppressMovable={true}
                    skipHeaderOnAutoSize={false}
                    onFirstDataRendered={this.onFirstDataRendered3.bind(this)}
                    rowHeight={window.innerWidth <= 587 ? 40 : 50}
                    headerHeight={window.innerWidth <= 587 ? 40 : 50}
                    frameworkComponents={this.state.frameworkComponents}
                    enableCellTextSelection={true}
                    ensureDomOrder={true}
                  ></AgGridReact>
                </div>
                <div
                  style={{
                    width: "100%",
                    marginTop: "15px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Paginator
                    currentPage={this.state.currentPage2}
                    totalPages={this.state.totalPages2}
                    onFirstPageClick={this.onFirstPageClick2.bind(this)}
                    onPreviousPageClick={this.onPreviousPageClick2.bind(this)}
                    onNextPageClick={this.onNextPageClick2.bind(this)}
                    onLastPageClick={this.onLastPageClick2.bind(this)}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {!this.state.dataLoading && (
          <div
            className="reportContaner"
            style={{ marginBottom: "100px", height: "unset" }}
          >
            <div className="reportTitleBar">گزارش کلی پیام‌های ارسالی</div>
            <div
              className="reportContent"
              style={{ paddingTop: "10px", paddingBottom: "10px" }}
            >
              <div
                className="pageContents"
                style={{ marginTop: "0px" }}
                ref={this.tableContainer4}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "fit-content",
                  }}
                >
                  <CustomButton
                    title="خروجی اکسل"
                    whiteSpace="noWrap"
                    imgHeight={20}
                    imgWidth={25}
                    flexDirection="row-reverse"
                    minHeight="35px"
                    ico={fileExcel}
                    onClick={() => {
                      this.setState({ ExcelDateModal: true, excelMode: 2 });
                    }}
                  />
                </div>
                <div className="tableContainer ag-theme-alpine">
                  <AgGridReact
                    enableRtl={true}
                    autoHeight={true}
                    animateRows={true}
                    enableBrowserTooltips={true}
                    tooltipMouseTrack={true}
                    suppressSizeToFit={false}
                    columnDefs={this.state.smsColumnDefs}
                    localeText={this.state.gridLocaleText}
                    rowData={this.state.smsRowData}
                    suppressDragLeaveHidesColumns={true}
                    suppressMovable={true}
                    skipHeaderOnAutoSize={false}
                    onFirstDataRendered={this.onFirstDataRendered4.bind(this)}
                    rowHeight={window.innerWidth <= 587 ? 40 : 50}
                    headerHeight={window.innerWidth <= 587 ? 40 : 50}
                    frameworkComponents={this.state.frameworkComponents}
                    enableCellTextSelection={true}
                    ensureDomOrder={true}
                  ></AgGridReact>
                </div>
                <div
                  style={{
                    width: "100%",
                    marginTop: "15px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Paginator
                    currentPage={this.state.currentPage3}
                    totalPages={this.state.totalPages3}
                    onFirstPageClick={this.onFirstPageClick3.bind(this)}
                    onPreviousPageClick={this.onPreviousPageClick3.bind(this)}
                    onNextPageClick={this.onNextPageClick3.bind(this)}
                    onLastPageClick={this.onLastPageClick3.bind(this)}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        <Modal
          show={this.state.ModalShow}
          size="sm"
          animation={true}
          onHide={this.hideModal.bind(this)}
          centered
        >
          <div className="settingContainer" style={{ padding: "10px" }}>
            <div className="ModalTitleSM">فیلتر لیست مشترکین</div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                overflow: "auto",
                marginTop: "20px",
                padding: "5px",
                width: "100%",
              }}
            >
              <div className="settingItemContainer">
                <div className="settingLabel">نام</div>
                <Form.Control
                  className={
                    this.state.CNameErrorText !== ""
                      ? "inputStyleForm inputError textAlignCenter"
                      : "inputStyleForm textAlignCenter"
                  }
                  placeholder="نام مشترک"
                  style={{ maxWidth: "120px" }}
                  type="text"
                  name="CNameValue"
                  onChange={this.textHandleChange.bind(this)}
                  value={this.state.CNameValue}
                />
              </div>

              <div className="settingItemContainer">
                <div className="settingLabel">موبایل</div>
                <Form.Control
                  maxLength="11"
                  className={
                    this.state.CPhoneErrorText !== ""
                      ? "inputStyleForm inputError textAlignCenter"
                      : "inputStyleForm textAlignCenter"
                  }
                  style={{ direction: "ltr", maxWidth: "120px" }}
                  placeholder="موبایل مشترک"
                  type="text"
                  name="CPhoneValue"
                  onChange={this.textHandleChange.bind(this)}
                  value={this.state.CPhoneValue}
                />
              </div>

              <div className="settingItemContainer">
                <div className="settingLabel" style={{ whiteSpace: "noWrap" }}>
                  حداقل اعتبار
                </div>
                <NumericFormat
                  className={
                    this.state.minCreditErrorText !== ""
                      ? "inputStyleForm inputError textAlignCenter form-control"
                      : "form-control inputStyleForm textAlignCenter"
                  }
                  placeholder="مبلغ"
                  style={{ direction: "ltr", maxWidth: "120px" }}
                  type="text"
                  name="minCreditValue"
                  value={this.state.minCreditValue}
                  allowNegative={true}
                  displayType={"input"}
                  thousandSeparator={true}
                  isNumericString
                  onValueChange={(values) => {
                    this.setState({ minCreditValue: values.value });
                  }}
                />
              </div>

              <div className="settingItemContainer">
                <div className="settingLabel" style={{ whiteSpace: "noWrap" }}>
                  حداکثر اعتبار
                </div>
                <NumericFormat
                  className={
                    this.state.maxCreditErrorText !== ""
                      ? "inputStyleForm inputError textAlignCenter form-control"
                      : "form-control inputStyleForm textAlignCenter"
                  }
                  placeholder="مبلغ"
                  style={{ direction: "ltr", maxWidth: "120px" }}
                  type="text"
                  name="maxCreditValue"
                  value={this.state.maxCreditValue}
                  allowNegative={true}
                  displayType={"input"}
                  thousandSeparator={true}
                  isNumericString
                  onValueChange={(values) => {
                    this.setState({ maxCreditValue: values.value });
                  }}
                />
              </div>

              <div className="settingItemContainer">
                <div style={{ flex: "1" }}>
                  <CustomButton
                    title="انتخاب گروه"
                    minHeight="35px"
                    onClick={this.onCustomerGroupsClick.bind(this)}
                  />
                </div>

                {this.state.selectedGroupList.length > 0 && (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "wrap",
                      marginTop: "10px",
                    }}
                  >
                    {this.state.selectedGroupList.map((item, i) => {
                      return this.state.groupList.map((item1, i1) => {
                        if (item === item1.id) {
                          return (
                            <div
                              style={{
                                padding: "5px",
                                backgroundColor: "var(--gray1)",
                                border: "1px solid var(--brown1)",
                                borderRadius: "4px",
                                margin: "5px",
                                textAlign: "center",
                                position: "relative",
                              }}
                            >
                              {item1.name}
                              <div
                                key={i}
                                style={{
                                  width: "15px",
                                  height: "15px",
                                  backgroundColor: "var(--brown1)",
                                  position: "absolute",
                                  right: "-8px",
                                  top: "-7px",
                                  borderRadius: "50%",
                                  textAlign: "center",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  color: "white",
                                  fontSize: "10px",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  let list = JSON.parse(
                                    JSON.stringify(this.state.selectedGroupList)
                                  );
                                  let temp = list.filter((el) => el !== item);

                                  this.setState({
                                    selectedGroupList: temp,
                                  });
                                }}
                              >
                                &#10006;
                              </div>
                            </div>
                          );
                        } else return null;
                      });
                    })}
                  </div>
                )}
              </div>
            </div>

            <div
              style={{
                width: "100%",
                maxWidth: "500px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "20px",
                alignItems: "center",
              }}
            >
              <div style={{ flex: "1" }}>
                <CustomButton
                  title="اعمال فیلتر"
                  loading={this.state.writingProgress}
                  imgHeight={20}
                  imgWidth={25}
                  minHeight="35px"
                  img={Tick}
                  onClick={this.onConfirm.bind(this)}
                />
              </div>
              <div style={{ minWidth: "10px" }} />
              <div style={{ flex: "0.8" }}>
                <CustomButton
                  title="انصراف"
                  imgHeight={19}
                  backColor="var(--black1)"
                  imgWidth={25}
                  minHeight="35px"
                  img={Cancel}
                  onClick={this.hideModal.bind(this)}
                />
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          show={this.state.ModalShow2}
          animation={true}
          size="sm"
          backdrop="static"
          backdropClassName="backdropClassName"
          onHide={this.hideModal2.bind(this)}
          centered
        >
          {this.state.ModalShow2 && (
            <ListViewer
              groups={true}
              currentSelected={this.state.selectedGroupList}
              list={this.state.groupList}
              loading={this.state.groupListLoading}
              onConfirmGroups={this.onConfirmGroups.bind(this)}
              hideModal={this.hideModal2.bind(this)}
            />
          )}
        </Modal>

        <Modal
          show={this.state.ModalShow3}
          animation={true}
          // size="lg"
          contentClassName="contanetStyleModal"
          onHide={this.hideModal3.bind(this)}
          centered
        >
          {this.state.modal3Loading && (
            <div
              style={{
                display: "flex",
                width: "90vw",
                maxWidth: "1200px",
                height: "75vh",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <WhisperSpinner
                size={50}
                color="var(--brown1)"
                frontColor="var(--brown1)"
                backColor="var(--brown1)"
                loading={true}
              />
            </div>
          )}
          {!this.state.modal3Loading && (
            <div className="RestaurantsListTitle">{this.state.reportTitle}</div>
          )}

          {!this.state.modal3Loading && (
            <div
              className="pageContents"
              style={{ width: "90vw", height: "auto", alignItems: "center" }}
              ref={this.tableContainer1}
            >
              {this.state.showCustomerExtraInfo && (
                <div className="reportExtraInfoMainContainer">
                  <div className="reportExtraInfoContainer">
                    <div className="singleInfo" style={{ marginTop: "20px" }}>
                      <div style={{ marginLeft: "10px", marginBottom: "10px" }}>
                        تعداد اعتبارهای دريافتی:{" "}
                      </div>
                      <NumericFormat
                        className="singleInfoNumberValue"
                        value={this.state.TotalCreditsCount}
                        displayType={"text"}
                        thousandSeparator={true}
                        suffix={" عدد"}
                      />
                    </div>
                    <div className="singleInfo" style={{ marginTop: "20px" }}>
                      <div style={{ marginLeft: "10px", marginBottom: "10px" }}>
                        اعتبار فعلی:{" "}
                      </div>
                      <NumericFormat
                        className="singleInfoNumberValue"
                        value={this.state.CurrentCredit}
                        displayType={"text"}
                        thousandSeparator={true}
                        suffix={" " + this.state.priceUnit}
                      />
                    </div>
                    <div className="singleInfo" style={{ marginTop: "20px" }}>
                      <div style={{ marginLeft: "10px", marginBottom: "10px" }}>
                        مجموع اعتبار دريافتی:{" "}
                      </div>
                      <NumericFormat
                        className="singleInfoNumberValue"
                        value={this.state.GetCredit}
                        displayType={"text"}
                        thousandSeparator={true}
                        suffix={" " + this.state.priceUnit}
                      />
                    </div>
                    <div className="singleInfo" style={{ marginTop: "20px" }}>
                      <div style={{ marginLeft: "10px", marginBottom: "10px" }}>
                        مجموع اعتبار استفاده شده:{" "}
                      </div>
                      <NumericFormat
                        className="singleInfoNumberValue"
                        value={this.state.UsedCredit}
                        displayType={"text"}
                        thousandSeparator={true}
                        suffix={" " + this.state.priceUnit}
                      />
                    </div>
                    <div className="singleInfo" style={{ marginTop: "20px" }}>
                      <div style={{ marginLeft: "10px", marginBottom: "10px" }}>
                        مجموع اعتبار منقضی شده:{" "}
                      </div>
                      <NumericFormat
                        className="singleInfoNumberValue"
                        value={this.state.ExpireCredit}
                        displayType={"text"}
                        thousandSeparator={true}
                        suffix={" " + this.state.priceUnit}
                      />
                    </div>
                  </div>
                </div>
              )}
              <div
                className="tableContainer ag-theme-alpine"
                style={{ minHeight: "55vh", height: "55vh" }}
              >
                <div
                  style={{
                    flex: "1",
                    width: "100%",
                    flexGrow: 1,
                    flexShrink: 0,
                    flexBasis: 0,
                  }}
                >
                  <AgGridReact
                    enableRtl={true}
                    autoHeight={true}
                    animateRows={true}
                    enableBrowserTooltips={true}
                    tooltipMouseTrack={true}
                    suppressSizeToFit={false}
                    columnDefs={this.state.customerColumnDefs}
                    localeText={this.state.gridLocaleText}
                    rowData={this.state.customerRowData}
                    suppressDragLeaveHidesColumns={true}
                    suppressMovable={true}
                    skipHeaderOnAutoSize={false}
                    onFirstDataRendered={this.onFirstDataRendered1.bind(this)}
                    rowHeight={window.innerWidth <= 587 ? 40 : 50}
                    headerHeight={window.innerWidth <= 587 ? 40 : 50}
                    frameworkComponents={this.state.frameworkComponents}
                    enableCellTextSelection={true}
                    ensureDomOrder={true}
                  ></AgGridReact>
                </div>
              </div>

              <div
                style={{
                  width: "100%",
                  marginTop: "15px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Paginator
                  currentPage={this.state.currentPage1}
                  totalPages={this.state.totalPages1}
                  onFirstPageClick={this.onFirstPageClick1.bind(this)}
                  onPreviousPageClick={this.onPreviousPageClick1.bind(this)}
                  onNextPageClick={this.onNextPageClick1.bind(this)}
                  onLastPageClick={this.onLastPageClick1.bind(this)}
                />
              </div>

              <div
                style={{
                  width: "100%",
                  maxWidth: "250px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "20px",
                  alignItems: "center",
                }}
              >
                <div style={{ flex: "1" }}>
                  <CustomButton
                    title="بستن"
                    imgHeight={19}
                    backColor="var(--black1)"
                    imgWidth={25}
                    minHeight="35px"
                    img={Cancel}
                    onClick={this.hideModal3.bind(this)}
                  />
                </div>
              </div>
            </div>
          )}
        </Modal>

        <Modal
          show={this.state.ModalShow4}
          animation={true}
          backdrop="static"
          backdropClassName="backdropClassName"
          contentClassName="contanetStyleModal"
          onHide={this.hideModal4.bind(this)}
          centered
        >
          <div className="RestaurantsListTitle">
            {this.state.detailReportTitle}
          </div>
          <div
            className="pageContents"
            style={{
              width: "90vw",
              maxWidth: "800px",
              height: "auto",
              alignItems: "center",
            }}
            ref={this.tableContainer2}
          >
            <div
              className="tableContainer ag-theme-alpine"
              style={{ minHeight: "45vh", height: "45vh" }}
            >
              <div
                style={{
                  flex: "1",
                  width: "100%",
                  flexGrow: 1,
                  flexShrink: 0,
                  flexBasis: 0,
                }}
              >
                <AgGridReact
                  enableRtl={true}
                  autoHeight={true}
                  animateRows={true}
                  enableBrowserTooltips={true}
                  tooltipMouseTrack={true}
                  suppressSizeToFit={false}
                  columnDefs={this.state.detailColumnDefs}
                  localeText={this.state.gridLocaleText}
                  rowData={this.state.detailRowData}
                  suppressDragLeaveHidesColumns={true}
                  suppressMovable={true}
                  skipHeaderOnAutoSize={false}
                  onFirstDataRendered={this.onFirstDataRendered2.bind(this)}
                  rowHeight={window.innerWidth <= 587 ? 40 : 50}
                  headerHeight={window.innerWidth <= 587 ? 40 : 50}
                  frameworkComponents={this.state.frameworkComponents}
                  enableCellTextSelection={true}
                  ensureDomOrder={true}
                ></AgGridReact>
              </div>
            </div>

            <div
              style={{
                width: "100%",
                maxWidth: "250px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "20px",
                alignItems: "center",
              }}
            >
              <div style={{ flex: "1" }}>
                <CustomButton
                  title="بستن"
                  imgHeight={19}
                  backColor="var(--black1)"
                  imgWidth={25}
                  minHeight="35px"
                  img={Cancel}
                  onClick={this.hideModal4.bind(this)}
                />
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          show={this.state.ExcelDateModal}
          size="sm"
          animation={true}
          onHide={() => {
            this.setState({ ExcelDateModal: false });
          }}
          centered
        >
          <div className="settingContainer" style={{ padding: "10px" }}>
            <div className="ModalTitleSM">انتخاب بازه زمانی</div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                overflow: "auto",
                marginTop: "20px",
                padding: "5px",
                width: "100%",
              }}
            >
              <div className="settingItemContainer">
                <div className="settingLabel">شروع:</div>
                <DatePicker
                  ref={this.datepicker1}
                  value={this.state.dateValue1}
                  inputClass="form-control inputStyleForm textAlignCenter"
                  calendar="persian"
                  locale="fa"
                  weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
                  format="YYYY/MM/DD"
                  animation
                  className="rmdp-mobile bluee"
                  onChange={(valuee) => this.dateChange1(valuee)}
                  maxDate={this.state.maxDateStart}
                  editable={false}
                  inputMode="none"
                  placeholder="شروع"
                />
              </div>
              <div className="settingItemContainer">
                <div className="settingLabel">پایان:</div>
                <DatePicker
                  ref={this.datepicker2}
                  value={this.state.dateValue2}
                  inputClass="form-control inputStyleForm textAlignCenter"
                  calendar="persian"
                  locale="fa"
                  weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
                  format="YYYY/MM/DD"
                  animation
                  className="rmdp-mobile bluee"
                  onChange={(valuee) => this.dateChange2(valuee)}
                  minDate={this.state.minDate}
                  maxDate={this.state.maxDate}
                  editable={false}
                  inputMode="none"
                  placeholder="پایان"
                />
              </div>

              <div
                style={{
                  width: "100%",
                  maxWidth: "500px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "20px",
                  alignItems: "center",
                }}
              >
                <div style={{ flex: "1" }}>
                  <CustomButton
                    title="دریافت فایل"
                    loading={this.state.excelProgress}
                    imgHeight={20}
                    imgWidth={25}
                    minHeight="35px"
                    ico={downloadIcon}
                    onClick={() => {
                      switch (this.state.excelMode) {
                        case 1: {
                          this.GetAccountsExcel();
                          break;
                        }
                        case 2: {
                          this.GetSMSesExcel();
                          break;
                        }
                        default:
                          break;
                      }
                    }}
                  />
                </div>
                <div style={{ minWidth: "10px" }} />
                <div style={{ flex: "0.8" }}>
                  <CustomButton
                    title="انصراف"
                    imgHeight={19}
                    backColor="var(--black1)"
                    imgWidth={25}
                    minHeight="35px"
                    img={Cancel}
                    onClick={() => {
                      this.setState({ ExcelDateModal: false });
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
